export function typeable (node, type) {
	if (type && type != node.getAttribute('type')) 
		node.setAttribute('type', type)

	return {
		destroy() {}
	}
}